import { useData } from "@/lib/data";
import { koliPairs } from "@/lib/api";
import { Input } from "@/components/ui/input";
import KoliTypeSelect from "@/components/KoliTypeSelect";

export const sizesFromKoli = (type, n) => {
  const sizes = {};
  if (type) Object.entries(type.ratios).forEach(([s, r]) => { sizes[s] = r * n; });
  return sizes;
};

// Auto-fills sizes from koli type x koli count
export default function KoliQty({ typeId, count, onChange, testIdPrefix }) {
  const { koliTypes } = useData();
  const selectedId = typeId || koliTypes[0]?.id || "";
  const type = koliTypes.find((k) => k.id === selectedId);
  const n = parseInt(count) || 0;

  const emit = (tid, c) => {
    const t = koliTypes.find((k) => k.id === tid);
    onChange({ koli_type_id: tid, koli_count: c, sizes: sizesFromKoli(t, parseInt(c) || 0) });
  };

  return (
    <div className="flex flex-col gap-2" data-testid={`${testIdPrefix}-koli-qty`}>
      <KoliTypeSelect value={selectedId} onChange={(v) => emit(v, count)} testId={`${testIdPrefix}-koli-type`}
        className="min-w-0 [&>span]:truncate" />
      <div className="flex items-center gap-2">
        <Input type="number" min={0} inputMode="numeric" placeholder="Toplam koli" value={count}
          onChange={(e) => emit(selectedId, e.target.value)} data-testid={`${testIdPrefix}-koli-count`}
          className="zs-size-input text-center h-11 flex-1 bg-[#FFFBF4] border-[#DCCFB8] font-mono text-lg" />
        <span className="text-sm font-mono text-[#B45309] font-bold whitespace-nowrap" data-testid={`${testIdPrefix}-koli-pairs`}>
          = {n * koliPairs(type?.ratios)} çift
        </span>
      </div>
    </div>
  );
}
